export const labels = {
  buttons: {
    search: "検索",
    create: "登録",
    update: "更新",
    delete: "削除",
    deleteDetail: "明細削除",
    excel: "Excel出力",
    close: "閉じる",
    allselect: "全選択",
    supplement: "補足",
    component: "構成",
    copy: "複製",
    detail: "詳細",
    juchuCancel: "受注キャンセル",
    decide: "確定",
    print: "印刷",
    execute: "実行",
    cancel: "キャンセル",
    ok: "OK",
    createDetail: "明細登録",
    updateDetail: "明細更新",
    calculate: "計算",
    correct: "訂正",
    ukeharai: "受払照会",
    hikiate: "引当照会",
    nyukayotei: "入荷予定照会",
    return: "戻る",
    excelImport: "EXCEL取込",
    run: "実行",
    resultReport: "結果レポート出力",
    reflectionCheck: "反映結果確認",
    reflect: "反映",
    CompleteAllSelected: "完了全選択",
    CompleteCancellation: "完了全解除",
    SelectAll: "全選択",
    SelectEmptyLocation: "空ロケ選択",
    ReleaseAll: "全解除",
    BatchEntryExecution: "一括入力実行",
    read: "読込み",
    deleteUriage: "売上削除",
    output: "出力",
    clampingrun: "締処理実行",
    clampingcancel: "締処理キャンセル",
    linedeletion: "行削除",
    back: "戻る",
    reserveExecution: "実行予約",
  },
  selects: {
    none: "未設定",
  },
  tabs: {
    new: "新規登録",
    edit: "編集",
  },
  dialog: {
    fieldReset: "編集中の入力内容が初期化されます。切り替えてよろしいですか。",
    meisaiReset: "明細の内容が削除されます。変更してよろしいですか。",
    juchuResetTujo:
      "受注区分を通常受注に切り替えると入力値が全てクリアされます。よろしいですか？",
    juchuResetMikomi:
      "受注区分を見込品生産に切り替えると入力値が全てクリアされます。よろしいですか？",
    createCheck:
      "明細入力部の変更が反映されていません。登録してもよろしいですか？",
    updateCheck:
      "明細入力部の変更が反映されていません。更新してもよろしいですか？",
    nyukinDelCheck:
      "明細データが存在しないため、このデータは削除されます。よろしいですか？",
    createConfirm: "登録します。よろしいですか？",
    correctConfirm: "訂正します。よろしいですか？",
    updateConfirm: "更新します。よろしいですか？",
    deleteConfirm: "削除します。よろしいですか？",
    createConfirmMessage: "正常に登録が完了しました。",
    updateConfirmMessage: "正常に更新が完了しました。",
    deleteConfirmMessage: "正常に削除が完了しました。",
    juchuworkImport: "受注データの取り込みに成功しました。",
    createMasterTitle: "マスタ登録",
    updateMasterTitle: "マスタ更新",
    deleteMasterTitle: "マスタ削除",
    masterExcelConfirmMessage: "出力します。よろしいですか？",
  },
};
